import * as React from 'react';
import { useFela } from 'react-fela';
import { createSpacing } from './base';
import { Flex } from './Flex';
import { createResponsiveStyles, getValidChildren } from './utils';
export var StackDirection;
(function (StackDirection) {
    StackDirection["VERTICAL"] = "VERTICAL";
    StackDirection["HORIZONTAL"] = "HORIZONTAL";
})(StackDirection || (StackDirection = {}));
function createStackCssStyles(props, theme) {
    const { stackDirection, alignItems, justifyContent, spacing = 1 } = props;
    return {
        flexDirection: stackDirection === StackDirection.VERTICAL ? 'column' : 'row',
        flexWrap: 'nowrap',
        alignItems,
        justifyContent,
        height: justifyContent !== undefined && StackDirection.VERTICAL ? '100%' : undefined,
        width: justifyContent !== undefined && StackDirection.HORIZONTAL ? '100%' : undefined,
        '& > *:not(:first-child)': {
            marginTop: stackDirection === StackDirection.VERTICAL ? createSpacing(theme, spacing) : 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: stackDirection === StackDirection.HORIZONTAL ? createSpacing(theme, spacing) : 0,
        },
    };
}
export const Stack = ({ children, divider, ...otherProps }) => {
    const { theme } = useFela();
    const style = createResponsiveStyles(otherProps, createStackCssStyles, theme);
    const hasDivider = !!divider;
    const validChildren = getValidChildren(children);
    const nextChildren = !hasDivider
        ? children
        : validChildren.map((child, index) => {
            const key = typeof child.key !== 'undefined' ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const nextDivider = isLast ? null : React.cloneElement(divider);
            return (React.createElement(React.Fragment, { key: key },
                child,
                nextDivider));
        });
    return React.createElement(Flex, { style: style }, nextChildren);
};
export const VStack = ({ children, ...otherProps }) => {
    return (React.createElement(Stack, { stackDirection: StackDirection.VERTICAL, ...otherProps }, children));
};
export const HStack = ({ children, ...otherProps }) => {
    return (React.createElement(Stack, { stackDirection: StackDirection.HORIZONTAL, ...otherProps }, children));
};
//# sourceMappingURL=Stack.js.map